/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core';

const AddModuleDialogStyles = makeStyles((theme: Theme) =>
	createStyles({
		dialogTitle: {
			display: 'flex',
			justifyContent: 'space-between',
			fontSize: '1.1rem',
			fontFamily: theme.typography.fontFamilyBold,
		},
		dialogContent: {
			paddingBottom: theme.spacing(3),
		},
		dialogActions: {
			padding: theme.spacing(2, 3, 3),
			'& button': {
				width: '100%',
			},
		},
		closeButton: {
			color: '#3A3A3A',
			opacity: '0.6',
			'&:hover': {
				cursor: 'pointer',
			},
		},
		headline: {
			fontFamily: theme.typography.fontFamilyBold,
		},
		row: {
			padding: theme.spacing(1.5, 1),
			'&:nth-child(odd)': {
				backgroundColor: '#E1E1E3',
			},
		},
		content: {
			display: 'flex',
			'&:hover': {
				cursor: 'pointer',
			},
		},
		addButton: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'flex-start',
		},
		truncated: {
			width: '250px',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
		flex: {
			display: 'flex',
		},
		contentContainer: {
			paddingTop: theme.spacing(1),
		},
		loadingContainer: {
			display: 'flex',
			justifyContent: 'center',
			margin: theme.spacing(8, 0),
		},
		loading: {
			color: theme.palette.secondary.light,
		},
	})
);

export default AddModuleDialogStyles;
